import { render } from "./InstgramPostReview.vue?vue&type=template&id=43b86c46&scoped=true"
import script from "./InstgramPostReview.vue?vue&type=script&lang=js"
export * from "./InstgramPostReview.vue?vue&type=script&lang=js"

import "./InstgramPostReview.vue?vue&type=style&index=0&id=43b86c46&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b86c46"]])

export default __exports__